// extracted by mini-css-extract-plugin
export default {"header":"JsonData_header__Q5Eiw","container":"JsonData_container__IHMT+"};